import { createSelector } from 'reselect';
import { prop } from 'ramda';
import { decamelizeKeys } from 'humps';
import { selectUserData as selectAuthData } from '../auth';
import { selectUserData } from '../user';

export const selectAnalyticsDomain = prop('analytics');

export const selectUserIntercomData = createSelector(
  selectAuthData,
  selectUserData,
  (authData = {}, userData = {}) =>
    decamelizeKeys({
      email: authData.email,
      userId: authData.uid,
      createdAt: authData.createdAt ? +authData.createdAt / 1000 : undefined,
      name: userData.firstName,
      marketingOptIn: userData.marketingAgreement || false,
    })
);
